jQuery(document).ready(function ($) {
  // $("#sortable").sortable({
  //     // connectWith: ".connectedSortable"
  //     cancel: ".state-disabled"
  // });
  // if (typeof iamge_errors !== 'undefined') {
  //     if (iamge_errors) {
  //         $("#bookImageUploadModal").modal('show');
  //     }
  // }
});

$(document).on("click", "ul li a.view-more", function () {
  var current = $(this);
  current.parents(".manage-clip").find(".clip-body-content").slideToggle();
  current.parents(".manage-clip").find(".clip-body-expand").slideToggle();
  current.parents(".manage-clip").children(".maincontent").find("div.image").css({ "margin-bottom": "10px" });
  current.removeClass("view-more");
  current.addClass("expand-more");
  return false;
});
$(document).on("click", "ul li a.expand-more", function () {
  var current = $(this);
  current.parents(".manage-clip").find(".clip-body-content").slideToggle();
  current.parents(".manage-clip").find(".clip-body-expand").slideToggle();
  current.parents(".manage-clip").children(".maincontent").find("div.image").css({ "margin-bottom": "-14px" });
  current.removeClass("expand-more");
  current.addClass("view-more");

  return false;
});

var li = $(".clip-list-section li"),
  ul = $(".manage-sidebar"),
  ul_height = 15;
// console.log(ul_height);
$(window).on("scroll", function () {
  var cur_pos = $(this).scrollTop();
  li.each(function () {
    var top = $(this).offset().top - ul_height,
      bottom = top + $(this).outerHeight();
    if (cur_pos >= top && cur_pos <= bottom) {
      ul.find(".tbl-of-contnent a").removeClass("active");
      li.removeClass("active");

      $(this).addClass("active");
      ul.find('a[href="#' + $(this).attr("id") + '"]').addClass("active");
    }
  });
});

ul.find(".tbl-of-contnent a").on("click", function () {
  var $el = $(this),
    id = $el.attr("href");

  $("html, body").animate(
    {
      scrollTop: $(id).offset().top - ul_height,
    },
    500
  );
  return false;
});

$(document).on("click", ".cover-section .remove-cover-photo-link", function (event) {
  event.preventDefault();
  var id = $(this).data("book");
  var type = $(this).data("type");
  axios
    .post(route("book.remove.photo", {}), {
      id: id,
      type: type,
    })
    .then((data) => {
      location.reload();
    });
});
